import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
const useStyles = makeStyles(theme => ({
  modalTitle: {
    textAlign: "center"
  },
  modalBody: {}
}));
const CustomDialog = props => {
  const classes = useStyles();
  const {
    open,
    setOpen,
    title,
    fullscreen,
    children
  } = props;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    fullScreen: fullscreen,
    onClose: () => setOpen(false)
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: classes.modalTitle
  }, title), children);
};
CustomDialog.propTypes = {
  setOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
export default CustomDialog;